import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddressComponent } from './address.component';
import { AddressDetailsComponent } from './address-details/address-details.component';
import { AddressListComponent } from './address-list/address-list.component';
import { AddressEditComponent } from './address-edit/address-edit.component';
import { AddressCreateComponent } from './address-create/address-create.component';

const routes: Routes = [{path: '', component: AddressComponent,
children:[
  {path : '', 
  component:AddressListComponent
  },
  {
    path : 'details/:id', 
    component:AddressDetailsComponent
  },
  {path : 'edit/:id',
   component:AddressEditComponent
   },
  {
    path : 'create/:id',
    component:AddressCreateComponent
    }
]}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AddressRoutingModule { }
